"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Handles string utilities.
 */
var StringUtility = /** @class */ (function () {
    function StringUtility() {
    }
    /**
     * Capitalizes first letter.
     *
     * @param text Text to use.
     * @returns String with first letter capitalized.
     */
    StringUtility.capitalizeFirstLetter = function (text) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    };
    /**
     * Kebab case to words.
     *
     * @param string String to convert.
     * @returns Text as kebab case.
     */
    StringUtility.kebabToCamelCase = function (string) {
        string = string.split('-');
        for (var i = 0, max = string.length; i < max; i++) {
            string[i] = this.capitalizeFirstLetter(string[i]);
        }
        return string.join('');
    };
    /**
     * Converts a camel case string to separate words with space inbetween.
     *
     * @param text Text to use.
     * @param [trim= ] Character to trim. Defaults to " ".
     * @returns Converted string.
     */
    StringUtility.trim = function (text, trim) {
        if (trim === void 0) { trim = ' '; }
        while (text.length > 0 && text.charAt(0) === trim) {
            text = text.substr(1);
        }
        while (text.length > 0 && text.charAt(text.length - 1) === trim) {
            text = text.slice(0, -1);
        }
        return text;
    };
    return StringUtility;
}());
exports.default = StringUtility;
//# sourceMappingURL=StringUtility.js.map